const FETCH_FEATURED_PRODUCTS_REQUEST = 'FETCH_FEATURED_PRODUCTS_REQUEST'
const FETCH_FEATURED_PRODUCTS_SUCCESS = 'FETCH_FEATURED_PRODUCTS_SUCCESS'
const FETCH_FEATURED_PRODUCTS_FAILURE = 'FETCH_FEATURED_PRODUCTS_FAILURE'
export { FETCH_FEATURED_PRODUCTS_REQUEST, FETCH_FEATURED_PRODUCTS_SUCCESS, FETCH_FEATURED_PRODUCTS_FAILURE }
